<template>
    <div>

        <!-- Top box -->

        <trax-ui-top-box :id="id" :endpoint="endpoint+'/'+courseId" :endpoint-params="endpointParams"
            :props="props" :map="map" :bus="bus"
            edit-button="1" :title2="programTitle" :link1="location"
            button-icon="edit" :button-name="lang.polaris.form.edit" :button-handler="edit"
            class="mb-1"
        ></trax-ui-top-box>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id" :bus="bus">
            <enac-custom-atpl-phase-edit-form :bus="bus" :id="id" :toastr-id="id+'-toastr'" :endpoint="endpoint">
            </enac-custom-atpl-phase-edit-form>
        </trax-ui-modal-default>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>

    </div>
</template>

<script>
    export default {

        props: {
            id: {default: 'trax-training-course-edit-top-box'},
            programTitle: null,
            courseId: null
        },

        data: function() {
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/phases',
                endpointParams: {
                    relations: ['location']
                },
                props: {
                    name: { source:'name' },
                    description: {source: 'description'},
                    entity_id: {source: 'entity_id'},
                    location: {source: 'location'},
                    meta: {source: 'meta'}
                },
                map: {
                    title1: 'name',
                    description: 'description',
                    backgroundImage: function(data) {
                        return data.meta && data.meta.background ? data.meta.background : 'default.jpg'
                    }
                },
                bus: new Vue()
            }
        },

        methods: {

            location: function(data) {
                if (!data.location) return null;
                return {value: data.location.name, icon: 'location_on'};
            },

            edit: function(data) {
                this.bus.$emit(this.id+'-update', data);
            }
        }

    }
</script>
